import React, { useEffect } from "react";

import Header from "../Component/Header";
import HomeSlider from "../Component/HomeSlider";
import ClassTabs from "../Component/ClassTabs";
import Calendar from "../Component/Calender";
import Activities from "../Component/Activities";
import Events from "../Component/Events";
import Message from "../Component/Message";
import Manager from "../Component/Manager";
import Gallery from "../Component/Gallery";
import TopperX from "../Component/TopperX";
import TopperXII from "../Component/TopperXII";
import Birthday from "../Component/Birthday";
import Footer from "../Component/Footer";
import LazyLoad from "react-lazyload";
import { Link } from "react-router-dom";
// import Popup from "../Component/Popup";
// import OnlineRegistration from "../Component/OnlineRegistration";

import TestimonialVideo from "../Component/TestimonialVideo";
const Home = () => {
  useEffect(() => {
    document.title = "Home -  CARMEL SCHOOL SARANGABAD";
  }, []);
  return (
    <>
      <Header></Header>
      <HomeSlider />
      <div class="erp_links">
        <a href="https://entab.online/CRMLSD" target="_blank">
          <img
            src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/DEMO3/public/Images/Campulogo.png"
            alt="CARMEL SARANGABAD"
            class="img-fluid"
          />
        </a>
      </div>
      <div className="container aboutmidsec aboutmidsecnew1 padded-sec">
        <div className="button">
          <Link to="#">
            <LazyLoad>
              <img
                src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/DEMO3/public/Images/vision-g.gif"
                alt="CSSK"
              />
            </LazyLoad>
            <p className="abt-txt">
              Vision{" "}
              <span>
                <Link to="/vision">Mission</Link>
              </span>
            </p>
          </Link>
        </div>
        <div className="button">
          <Link to="#">
            <LazyLoad>
              <img
                src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/DEMO3/public/Images/quotes-g.gif"
                alt="CSSK"
              />
            </LazyLoad>
            <p className="abt-txt">
              Manager{" "}
              <span>
                <Link to="/manager">Message</Link>
              </span>
            </p>
          </Link>
        </div>
        <div className="button">
          <Link to="#">
            <LazyLoad>
              <img
                src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/DEMO3/public/Images/quotes-g.gif"
                alt="CSSK"
              />
            </LazyLoad>
            <p className="abt-txt">
              Provincial’s{" "}
              <span>
                <Link to="/provisional">Message</Link>
              </span>
            </p>
          </Link>
        </div>
        <div className="button">
          <Link to="#">
            <LazyLoad>
              <img
                src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/DEMO3/public/Images/quotes-g.gif"
                alt="CSSK"
              />
            </LazyLoad>
            <p className="abt-txt">
              Principal{" "}
              <span>
                {" "}
                <Link to="/prinicipal">Message</Link>
              </span>
            </p>
          </Link>
        </div>
        <div className="button">
          <Link to="#">
            <LazyLoad>
              <img
                src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/DEMO3/public/Images/faculty-g.gif"
                alt="CSSK"
              />
            </LazyLoad>
            <p className="abt-txt">
              {" "}
              <Link to="/faculty">Faculty</Link>
            </p>
          </Link>
        </div>
        <div className="button">
          <Link to="#">
            <LazyLoad>
              <img
                src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/DEMO3/public/Images/student-g.gif"
                alt="CSSK"
              />
            </LazyLoad>
            <p className="abt-txt">
              Student
              <span> Council</span>
            </p>
          </Link>
        </div>
      </div>
      <div class="homeabout">
        <div className="container-fluid fulwidth">
          {/* <Thought /> */}
          <div className="row">
            <div className="col-xl-4 col-lg-12">
              <img
                src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/DEMO3/public/Images/aboutbg.png"
                className="img-fluid aboutimg"
                alt="CSSK"
              />
            </div>
            <div className="col-xl-5 col-lg-12">
              <div className="maintitle">
                <div class="d-flex ">
                  <img
                    src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/DEMO3/public/Images/about-vect.png"
                    alt="About Us"
                    className="img-fluid me-2"
                  />
                  <p className="mb-0">About Us</p>
                </div>

                <h1>Welcome to the school</h1>
              </div>

              <div className="aboutmiddec">
                <p>
                  Carmel School is a Christian Minority School administered by
                  the sisters of the congregation of the mother of Carmel
                  (C.M.C) an Indian Christian education body of wide and long
                  experience. The congregation was founded in 1866. Its main
                  work is education, aiming at the intellectual, social,
                  economic, moral and spiritual advancement of the people
                  particularly of women and children. This school is situated at
                  Sarangabad, Budge Budge and it comes under the religious
                  jurisdiction of the Roman Catholic Bishop of Baruipur.
                </p>
              </div>
              <div className="about-new-but">
                <p>
                  <a href="/about">Read More</a>
                </p>
              </div>
            </div>
            <div className="col-xl-3 col-lg-12">
              <div className="music-player-box">
                <p className="music-title">School Anthem</p>

                <audio controls className="custom-audio-player">
                  <source
                    src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/DEMO3/public/anthem.mp3"
                    type="audio/mpeg"
                  />
                  Your browser does not support the audio element.
                </audio>
              </div>
            </div>
          </div>
          <div className="col-12">
            <div className="aboutinfo">
              <div className="aboutinfobox">
                <div className="aboutinfoboximg">
                  <img
                    src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/DEMO3/public/Images/totalstudent.gif"
                    className="img-fluid"
                    alt="CSSK"
                  />
                </div>
                <div className="aboutinfoboxdesc">
                  <h6>2300+</h6>
                  <p>Total Students</p>
                </div>
              </div>
              <div className="aboutinfobox">
                <div className="aboutinfoboximg">
                  <img
                    src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/DEMO3/public/Images/totalstaff.gif"
                    className="img-fluid"
                    alt="CSSK"
                  />
                </div>
                <div className="aboutinfoboxdesc">
                  <h6>130+</h6>
                  <p>Total Staff</p>
                </div>
              </div>
              <div className="aboutinfobox">
                <div className="aboutinfoboximg">
                  <img
                    src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/DEMO3/public/Images/totalclass.gif"
                    className="img-fluid"
                    alt="CSSK"
                  />
                </div>
                <div className="aboutinfoboxdesc">
                  <h6>65+</h6>
                  <p>Total Classrooms</p>
                </div>
              </div>
              <div className="aboutinfobox">
                <div className="aboutinfoboximg">
                  <img
                    src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/DEMO3/public/Images/teacherstudent.gif"
                    className="img-fluid"
                    alt="CSSK"
                  />
                </div>
                <div className="aboutinfoboxdesc">
                  <h6>01:20</h6>
                  <p>Teacher Student Ratio</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="classSection">
           <div className="container-fluid fulwidth"> 
          <div className="row">
            <div className="col-lg-12">
              <div className="maintitle">
                <p>academics</p>
                <h1>Our curriculum</h1>
              </div>
              <ClassTabs />
            </div>
          </div>
        </div>
      </div>
      <div className="calendersec">
        <div className="container-fluid fulwidth">
          <div className="row">
            <div className="col-xl-6 col-lg-12">
              <div className="maintitle">
                <div className="d-flex align-items-center">
                  <img
                    src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/DEMO3/public/Images/date-ic.png"
                    alt="About Us"
                    className="img-fluid me-2"
                  />
                  <p className="mb-0">dates and events</p>
                </div>

                <h1>
                  academic calendar <span></span>
                </h1>
              </div>
              <Calendar />
              <Events />
            </div>
            <div className="col-xl-6 col-lg-12">
              <div className="maintitle new-tot">
                <div className="d-flex align-items-center">
                  <img
                    src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/DEMO3/public/Images/n-ic.png"
                    alt="About Us"
                    className="img-fluid me-2"
                  />
                  <p className="mb-0">happening in the school</p>
                </div>

                <h1>
                  Activities and Events<span></span>
                </h1>
              </div>
              <Activities />
            </div>
          </div>
        </div>
      </div>
      <div className="messagesec">
        <div className="container-fluid fulwidth">
          <div className="row">
            <div className="col-12">
              <div className="maintitle">
                <div className="d-flex align-items-center justify-content-center mx-auto">
                  <img
                    src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/DEMO3/public/Images/fac-sub-icon.png"
                    alt="About Us"
                    className="img-fluid me-2"
                  />
                  <p className="mb-0">from the desk of</p>
                </div>

                <h1>
                  Message section <span></span>
                </h1>
              </div>
            </div>

            {/* Manager / Message Section */}
            <div className="col-12">
              <div className="row g-4 justify-content-center">
                {/* Manager */}
                <div className="col-xxl-6 col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12">
                  <div className="message-box h-100">
                    <Message />
                  </div>
                </div>

                {/* Principal */}
                <div className="col-xxl-6 col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12">
                  <div className="message-box h-100">
                    <Manager />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="facilities">
        <div class="container-fluid fulwidth">
          <div class="row">
            <div className="col-lg-12">
              <div className="maintitle">
                <div className="d-flex align-items-center mx-auto">
                  <img
                    src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/DEMO3/public/Images/thumb.png"
                    alt="About Us"
                    className="img-fluid me-2"
                  />
                  <p className="mb-0">our infrastructure</p>
                </div>
                <h1>
                  facilities in school <span></span>
                </h1>
              </div>
            </div>
            <div className="row facilities-row g-3">
              <div class="col-xl-2 col-lg-6 col-md-6">
                <div className="facilitiesbox h-100 w-100">
                  <div className="facilitiesimg">
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/DEMO3/public/Images/facilitiesbg.gif"
                      className="img-fluid"
                    />
                    {/* <div className="facilitiesimg1">
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/DEMO3/public/Images/facilities1.gif"
                      className="img-fluid"
                    />
                  </div> */}
                  </div>
                  <h3>Transport</h3>
                  <p>
                    A safe, reliable, and convenient transportation system is
                    essential for every school. Our school transport service
                    ensures timely pickups and drop-offs with trained drivers,
                    dedicated attendants, and GPS-enabled vehicles. Designed to
                    reduce traffic congestion and support working parents, this
                    service prioritizes student safety, efficiency, and peace of
                    mind.
                  </p>
                </div>
              </div>
              <div class="col-xl-2 col-lg-6 col-md-6">
                <div className="facilitiesbox h-100 w-100">
                  <div className="facilitiesimg">
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/DEMO3/public/Images/football-player.gif"
                      className="img-fluid"
                    />
                    {/* <div className="facilitiesimg1">
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/DEMO3/public/Images/facilities2.gif"
                      className="img-fluid"
                    />
                  </div> */}
                  </div>
                  <h3>sports complex</h3>
                  <p>
                    The School Sports Complex is a dynamic space dedicated to
                    promoting physical fitness, teamwork, and holistic
                    development among students. Equipped with modern facilities
                    for indoor and outdoor games—such as basketball, football,
                    volleyball, athletics, and more.
                  </p>
                </div>
              </div>
              <div class="col-xl-2 col-lg-6 col-md-6">
                <div className="facilitiesbox h-100 w-100">
                  <div className="facilitiesimg">
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/DEMO3/public/Images/hotel.gif"
                      className="img-fluid"
                    />
                    {/* <div className="facilitiesimg1">
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/DEMO3/public/Images/facilities3.gif"
                      className="img-fluid"
                    />
                  </div> */}
                  </div>
                  <h3>infirmary</h3>
                  <p>
                    The school's medical facility is fully equipped to provide
                    immediate care and support to students in case of illness or
                    injury during school hours. The health room includes
                    dedicated beds for rest and observation, along with
                    essential first-aid supplies, a qualified nurse, and regular
                    health check-ups.
                  </p>
                </div>
              </div>
              <div class="col-xl-2 col-lg-6 col-md-6">
                <div className="facilitiesbox h-100 w-100">
                  <div className="facilitiesimg">
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/DEMO3/public/Images/elevator.gif"
                      className="img-fluid"
                    />
                    {/* <div className="facilitiesimg1">
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/DEMO3/public/Images/facilities4.gif"
                      className="img-fluid"
                    />
                  </div> */}
                  </div>
                  <h3>elevator</h3>
                  <p>
                    The school elevator is designed to provide easy and safe
                    accessibility across all floors of the campus. It is
                    especially helpful for students with special needs, staff
                    members, and visitors who may face difficulty using stairs.
                  </p>
                </div>
              </div>
              <div class="col-xl-2 col-lg-6 col-md-6">
                <div className="facilitiesbox h-100 w-100">
                  <div className="facilitiesimg">
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/DEMO3/public/Images/check-unscreen.gif"
                      className="img-fluid"
                    />
                    {/* <div className="facilitiesimg1">
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/DEMO3/public/Images/facilities5.gif"
                      className="img-fluid"
                    />
                  </div> */}
                  </div>
                  <h3>eco-friendly measures</h3>
                  <p>
                    Our school is committed to sustainability and environmental
                    responsibility through the adoption of eco-friendly measures
                    across the campus. These initiatives aim to educate students
                    about green living while reducing our ecological footprint.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    <div className="topper_bg padded-sec">
  <div className="container-fluid section-title">
    <div className="row">

      {/* Topper X */}
      <div className="col-xl-4 col-lg-12">
        <div className="row">
          <div className="col-md-12">
            <div className="maintitle">
              <p>Our Toppers</p>
              <h1>Topper X</h1>
            </div>
          </div>

          <div className="col-lg-12">
            <div className="topper-block">
              <div className="title">
                <div className="arrrow-btn"></div>
              </div>

              <TopperX />
            </div>

            <div className="d-flex justify-content-center">
              <Link
                to="/innertopperx"
                className="read-more-btn"
              >
                Read More <i className="bi bi-arrow-right"></i>
              </Link>
            </div>
          </div>
        </div>
      </div>

      {/* Topper XII */}
      <div className="col-xl-4 col-lg-12">
        <div className="row">
          <div className="col-md-12">
            <div className="maintitle">
              <p>Our Toppers</p>
              <h1>Topper XII</h1>
            </div>
          </div>

          <div className="col-lg-12">
            <div className="topper-block">
              <div className="title">
                <div className="arrrow-btn"></div>
              </div>

              <TopperXII />
            </div>

            <div className="d-flex justify-content-center">
              <Link
                to="/innertopperxii"
                className="read-more-btn"
              >
                Read More <i className="bi bi-arrow-right"></i>
              </Link>
            </div>
          </div>
        </div>
      </div>

      {/* Birthday */}
      <div className="col-xl-4 col-lg-12">
        <div className="maintitle">
          <p>Born on This Day</p>
          <h1>today’s birthday</h1>
        </div>

        <div className="col-lg-12">
          <div className="topper-block">
            <div className="title">
              <h2></h2>
            </div>
            <Birthday />
          </div>
        </div>
      </div>

    </div>
  </div>
</div>
      <div className="homegallery padded-sec">
        <div className="container-fluid fulwidth">
          <div className="row">
            <div className="col-md-12 section-title">
              <div className="maintitle text-center mx-auto">
                <div className="d-flex align-items-center mx-auto">
                  <img
                    src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/DEMO3/public/Images/photo-ic.png"
                    alt="About Us"
                    className="img-fluid me-2"
                  />
                  <p className="mb-0">photo gallery</p>
                </div>

                <h1>
                  captured memories <span></span>
                </h1>
              </div>
            </div>
            <div className="col-lg-12">
              <Gallery />
            </div>
          </div>
        </div>
      </div>
      <div className="chooseus padded-sec">
        <div className="container-fluid fulwidth">
          <div className="row">
            <div className="col-md-12 section-title">
              <div className="maintitle">
                <div className="d-flex align-items-center mx-auto">
                  <p className="mb-0">why choose us</p>
                </div>

                <h1>
                  what sets us apart <span></span>
                </h1>
              </div>
            </div>
            <div className="col-lg-12">
              <div className="chooseuspart">
                <div className="chooseuspartleft">
                  <div className="chooseuspartbox">
                    <div className="chooseuspartlftbox">
                      <img
                        src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/DEMO3/public/Images/chooseusicn1.png"
                        className="img-fluid"
                      />
                    </div>
                    <div className="chooseuspartrgtbox">
                      <h6>Mindful Time</h6>

                      <p>
                        Mindful Time is a calm, reflective moment of meditation
                        embedded into each school day, helping students enhances
                        emotional balance, mental clarity, and focus. This
                        practice prepares them to engage in the day’s learning
                        with mindfulness and positive energy, creating a
                        peaceful start that fosters academic and personal
                        growth.
                      </p>
                    </div>
                  </div>
                  <div className="chooseuspartbox">
                    <div className="chooseuspartlftbox">
                      <img
                        src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/DEMO3/public/Images/chooseusicn2.png"
                        className="img-fluid"
                      />
                    </div>
                    <div className="chooseuspartrgtbox">
                      <h6>Book Bloom </h6>

                      <p>
                        Book Bloom is a dedicated reading time designed to
                        nurture a love for literature and build essential
                        literacy skills. During this time, students engage in
                        silent reading, library exploration, and peer
                        discussions, helping them develop comprehension,
                        vocabulary, and critical thinking, and fostering a
                        lifelong passion for reading.
                      </p>
                    </div>
                  </div>
                  <div className="chooseuspartbox">
                    <div className="chooseuspartlftbox">
                      <img
                        src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/DEMO3/public/Images/chooseusicn3.png"
                        className="img-fluid"
                      />
                    </div>
                    <div className="chooseuspartrgtbox">
                      <h6>Right Reach </h6>

                      <p>
                        Through the Right Reach initiative, students are paired
                        with their peers to offer academic and emotional
                        support. This program promotes inclusivity, empathy, and
                        collaboration, helping students who may be struggling to
                        feel more connected and confident in their learning
                        journey while encouraging leadership and peer
                        responsibility.
                      </p>
                    </div>
                  </div>
                  <div className="chooseuspartbox">
                    <div className="chooseuspartlftbox">
                      <img
                        src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/DEMO3/public/Images/chooseusicn4.png"
                        className="img-fluid"
                      />
                    </div>
                    <div className="chooseuspartrgtbox">
                      <h6>Lead Point </h6>
                      <p>
                        {" "}
                        The Lead Point program empowers students to actively
                        participate in school governance through elected roles
                        in the Student Council. By being involved in
                        decision-making processes and leadership
                        responsibilities, students gain valuable skills in
                        democracy, teamwork, and leadership, preparing them for
                        roles of responsibility in the future.
                      </p>
                    </div>
                  </div>
                  <div className="chooseuspartbox">
                    <div className="chooseuspartlftbox">
                      <img
                        src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/DEMO3/public/Images/chooseusicn5.png"
                        className="img-fluid"
                      />
                    </div>
                    <div className="chooseuspartrgtbox">
                      <h6>Lingua Lift </h6>
                      <p>
                        {" "}
                        Lingua Lift enhances communication skills by immersing
                        students in structured language learning, where they
                        engage in three days of English communication and two
                        days in the regional language each week. This exposure
                        helps students become versatile communicators, improving
                        their fluency, confidence, and cultural understanding,
                        essential for global citizenship.
                      </p>
                    </div>
                  </div>
                  <div className="chooseuspartbox">
                    <div className="chooseuspartlftbox">
                      <img
                        src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/DEMO3/public/Images/chooseusicn6.png"
                        className="img-fluid"
                      />
                    </div>
                    <div className="chooseuspartrgtbox">
                      <h6>Skill Nest </h6>
                      <p>
                        {" "}
                        In Skill Nest, students engage in hands-on,
                        project-based learning that integrates life skills such
                        as critical thinking, problem-solving, emotional
                        intelligence, and teamwork. These activities are
                        designed to empower students to confidently handle
                        real-world challenges, building practical skills that go
                        beyond academic knowledge.
                      </p>
                    </div>
                  </div>
                </div>
                <div className="chooseuspartcenter">
                  <img
                    src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/DEMO3/public/Images/chooseusimg.png"
                    className="img-fluid chooseuspartcenterimg what mb-5"
                  />
                  {/* <div className="chooseuspartbox">
                    <button className="button what m-auto ">
                      <Link to="#">
                        Read More <i className="bi bi-arrow-right"></i>
                      </Link>
                    </button>
                  </div> */}
                </div>
                <div className="chooseuspartright">
                  <div className="chooseuspartbox">
                    <div className="chooseuspartrgtbox">
                      <h6 className="text-end">Heart Basket</h6>

                      <p>
                        Heart Basket is a unique initiative that encourages
                        students to bring an extra food packet each month to
                        donate to the underprivileged. Through this simple but
                        impactful act of sharing, students learn empathy, social
                        responsibility, and the value of contributing to their
                        community, fostering a spirit of kindness and
                        generosity.
                      </p>
                    </div>

                    <div className="chooseuspartlftbox">
                      <img
                        src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/DEMO3/public/Images/chooseusicn7.png"
                        className="img-fluid"
                      />
                    </div>
                  </div>
                  <div className="chooseuspartbox">
                    <div className="chooseuspartrgtbox">
                      <h6>Soul Stroke</h6>

                      <p>
                        {" "}
                        Soul Stroke is an initiative where students use the
                        medium of art to reflect on moral, social, and personal
                        values. Through creative expression, they explore
                        ethical themes, engage with societal issues, and build
                        emotional resilience, making art a powerful tool for
                        self-awareness and value-based learning.
                      </p>
                    </div>
                    <div className="chooseuspartlftbox">
                      <img
                        src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/DEMO3/public/Images/chooseusicn8.png"
                        className="img-fluid"
                      />
                    </div>
                  </div>
                  <div className="chooseuspartbox">
                    <div className="chooseuspartrgtbox">
                      <h6>Eco Echo </h6>

                      <p>
                        {" "}
                        Eco Echo fosters a commitment to environmental
                        sustainability. Students participate in activities like
                        tree planting, recycling, and waste reduction, helping
                        to create a greener, more sustainable school campus.
                        This initiative instills a sense of ecological
                        responsibility, encouraging students to become active
                        caretakers of the planet.
                      </p>
                    </div>
                    <div className="chooseuspartlftbox">
                      <img
                        src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/DEMO3/public/Images/chooseusicn9.png"
                        className="img-fluid"
                      />
                    </div>
                  </div>
                  <div className="chooseuspartbox">
                    <div className="chooseuspartrgtbox">
                      <h6>Inspire Times</h6>

                      <p>
                        {" "}
                        Inspire Times is a program where each month is dedicated
                        to a specific theme, incorporating events that align
                        with key learning objectives and desired outcomes. These
                        events, such as encourage students to explore new
                        concepts, engage in hands-on activities, and deepen
                        their knowledge across important events of the month to
                        celebrate diverse aspects of knowledge, values, and
                        culture through focused events .Thematic learning
                        enhances retention and makes learning more meaningful
                        and contextual.
                      </p>
                    </div>
                    <div className="chooseuspartlftbox">
                      <img
                        src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/DEMO3/public/Images/chooseusicn10.png"
                        className="img-fluid"
                      />
                    </div>
                  </div>
                  <div className="chooseuspartbox">
                    <div className="chooseuspartrgtbox">
                      <h6>Satsewa</h6>

                      <p>
                        {" "}
                        The Satsewa program is designed to encourage social
                        outreach and community service. Through this initiative,
                        students participate in charitable activities such as
                        visiting elderly homes, donating food, participating in
                        e-learning and teaching and supporting local causes.
                        Satsewa instills in students a deep sense of social
                        responsibility, empathy, and active citizenship,
                        reinforcing the importance of giving back to society.
                      </p>
                    </div>
                    <div className="chooseuspartlftbox">
                      <img
                        src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/DEMO3/public/Images/chooseusicn11.png"
                        className="img-fluid"
                      />
                    </div>
                  </div>
                  <div className="chooseuspartbox">
                    <div className="chooseuspartrgtbox">
                      <h6>Peter’s Merit Scholarship </h6>

                      <p>
                        {" "}
                        The Peter’s Merit Scholarship is a prestigious
                        recognition for academic excellence. Students who
                        achieve 97% or above in their annual academic
                        performance are awarded a 100% tuition fee waiver. This
                        scholarship not only rewards outstanding academic
                        achievement but also motivates students to strive for
                        excellence in their educational journey.
                      </p>
                    </div>
                    <div className="chooseuspartlftbox">
                      <img
                        src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/DEMO3/public/Images/chooseusicn12.png"
                        className="img-fluid"
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="testimonial_sec">
        <div className="container-fluid">
          <div className="row">
            <div className="col-md-12 section-title d-flex justify-content-center">
              <div className="maintitle d-flex flex-column align-items-center">
                <div className="d-flex align-items-center">
                  <img
                    src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/DEMO3/public/Images/test-icon.png"
                    alt="School Toppers"
                    className="img-fluid me-2"
                  />
                  <p className="mb-0">parents testimonial</p>
                </div>

                <h1 className="text-center">
                  THE DIFFERENCE, IN THEIR WORDS <span></span>
                </h1>
              </div>
            </div>

            <TestimonialVideo></TestimonialVideo>
          </div>
        </div>
      </div>
      <Footer />
    </>
  );
};

export default Home;
